<template>
<div>
  <v-card flat v-if='hrs' >
    <request-status :request='request' />
    <request-status :request='touchHoursReq' />
    <!-- <v-col cols=12 >
      <v-subheader class='overline' >{{hrs.title}}</v-subheader>
    </v-col> -->
    <v-card-text>
      <v-row>
        <v-col
          style='border-right: solid 1px #ccc; border-bottom:solid 1px #ccc;width:14%'
          v-for='(day, index) in dotw' :key='`${practitioner.id}-${day}-${index}`'
          class='text-center overline grey--text' >{{day}}</v-col>
      </v-row>
      <v-row>
        <v-col xs-cols="12" style='border-right: solid 1px #ccc;width:14%'
          v-for='(day, i) in dotw'
          :key='`h-${practitioner.id}-${day}-${i}`' >

          <v-btn outlined x-small block
            @click='newslot(hrs, day, "before")'
            color='primary'
            class='mt-3' >
            <v-icon x-small >mdi-plus</v-icon>
            Add hours
          </v-btn>

          <template v-if='getPeriods(hrs[day]) && getPeriods(hrs[day]).length > 0' >
            <v-chip outlined block close small class='mt-3' style='width:100%;'
              v-for='hr in getPeriods(hrs[day])' :key='hr'
              @click:close='clearPeriod(hrs, day, hr)' >
              {{hr}}
            </v-chip>
          </template>
          <span v-else class='mt-3' >
            Not available for booking
          </span>
          <v-btn outlined x-small block
            @click='newslot(hrs, day, "after")'
            color='primary'
            class='mt-3' >
            <v-icon x-small >mdi-plus</v-icon>
            Add hours
          </v-btn>
        </v-col>
      </v-row>
    </v-card-text>
    <!-- <pre v-text='hrs' /> -->
    <v-card-actions>
      <v-switch persistent-hint
        label='Auto-Save'
        v-model='autoSave'
        hint='Automatically save everytime you add a new time block' />
      <v-spacer />
      <v-btn @click='save(hrs)' color='primary' :loading='request.loading' >Save</v-btn>
    </v-card-actions>

    <v-dialog v-model='hrsDialog' width='600' >
      <v-card>
        <v-card-title class='subtitle-1 overline' >
          Add a new block of time
          <v-spacer />
          <v-btn @click='hrsDialog=false' icon >
            <v-icon >mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col cols=6 >
              Start time
              <v-time-picker v-model='activehrs.from' :min='activehrs.min' :max='activehrs.max' format="24hr" />
              <!-- <v-select v-model='activehrs.from' :items='fromHours' /> -->
            </v-col>
            <v-col cols=6 >
              End time
              <v-time-picker v-model='activehrs.to' :min='activehrs.from' :max='activehrs.max' format="24hr" />
              <!-- <v-select v-model='activehrs.to' :min='activehrs.from' :items='fromHours' /> -->
            </v-col>
          </v-row>
        </v-card-text>
        <!-- <pre v-text='isValid' /> -->
        <v-alert text v-if='isValid !== true' v-text='isValid' />
        <v-divider />

        <v-card-actions >
          <v-spacer />
          <v-btn
            :disabled="isValid !== true"
            @click='addTimeslot' color='primary' >Add</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-card>
  <v-card v-else>
    <v-card-actions >
      <v-spacer />
      <v-btn
        :loading="touchHoursReq.loading"
        @click='touchHours'
        class='primary' >Create </v-btn>
    </v-card-actions>
  </v-card>
</div>
</template>
<script>
import Vue from 'vue'
import {DateTime} from 'luxon'
export default {
  name: 'HoursView',
  props: {
    spaceId: { required: true },
    value: { type: Object, required: false },
    location: { type: Object, required: false },
    practitioner: { type: Object, required: true }
  },
  data () {
    return {
      autoSave: true,
      request: {
        resource: 'ag.practitioner.hours'
      },
      touchHoursReq: {
        resource: 'ag.spaces.addresses',
        extra: 'touch_hours'
      },
      dotw: ['mon', 'tues', 'wed', 'thurs', 'fri', 'sat', 'sun'],
      hrsDialog: false,
      activehrs: {
        from: null,
        to: null,
        min: null,
        hrs: null,
        day: null
      }
    }
  },
  computed: {
    practitionerId () {
      return this.practitioner.id
    },
    hrs () {
      if (this.value && this.value.id) { return this.value }
      return this.location.operation_hours.find((hrs) => {
        return String(hrs.practitioner) === String(this.practitionerId)
      })
    },
    selectedFrom () {
      return this.activehrs.from
    },
    selectedTo () {
      return this.activehrs.to
    },
    endBeforeStart () {
      return DateTime.fromISO(this.selectedFrom) > DateTime.fromISO(this.selectedTo)
    },
    touchHoursReqStatus () {
      return this.touchHoursReq.status
    },
    isValid () {
      if (this.selectedFrom && this.selectedTo) {
        if (this.endBeforeStart) {
          return 'End time must be after start time'
        }
      } else {
        if (!this.selectedFrom) { return 'please chose a start time' }
        if (!this.selectedTo) { return 'please chose an end time' }
      }
      return true
    }
  },
  watch: {
    selectedFrom () {
      if (!this.selectedTo || this.endBeforeStart) {
        this.activehrs.to = this.selectedFrom
      }
    },
    touchHoursReqStatus () {
      if (this.touchHoursReqStatus === 200) {
        this.$emit('refresh', this.touchHoursReq)
      }
    }
  },
  methods: {
    save (hrs) {
      // this.request.extra = 'operating-hours/' + this.location.id
      this.request.resourceId = hrs.id
      this.request.data = hrs
      this.$request('save', this.request)
    },
    touchHours () {
      if (this.spaceId && this.location && this.location.id) {
        this.touchHoursReq.kwargs = { spaceId: this.spaceId }
        this.touchHoursReq.resourceId = this.location.id
        this.touchHoursReq.method = 'post'
        this.$request('save', this.touchHoursReq)
      }
    },
    getPeriods (hrString) {
      if (hrString) {
        return hrString.split('|')
      }
      return []
    },
    trimPipes (str) {
      if (str) {
        if (str.startsWith('|')) {
          str = str.substr(1)
        }
        if (str.endsWith('|')) {
          str = str.substr(0, str.length-1)
        }
      }
      return str
    },
    clearPeriod (hrs, day, hr) {
      hrs[day] = hrs[day].replace(hr, '')
      hrs[day] = this.trimPipes(hrs[day])
      // str.replace(substr, '')
      this.save(hrs)
    },
    newslot (hrs, day, position) {
      this.hrsDialog=true
      let hr = hrs[day]
      let periods = hr.split('|')
      let lastPeriod = periods[periods.length - 1]
      let hrBits = lastPeriod.split('-')
      let lastHrs = null
      let firstHrs = null
      let min = null
      let max = null

      if (hrBits.length > 0) {
        lastHrs = hrBits[hrBits.length - 1]
        firstHrs = hrBits[0]
      }
      if (!firstHrs) {
        firstHrs = '08:00'
      }
      if (!lastHrs) {
        lastHrs = '08:00'
      } else {
        if (position === 'before') {
          min = firstHrs
        } else {
          min = lastHrs
        }
      }
      Vue.set(this.activehrs, 'hrs', hrs)
      Vue.set(this.activehrs, 'day', day)
      Vue.set(this.activehrs, 'min', min)
      Vue.set(this.activehrs, 'max', max)
      if (position === 'before') {
        Vue.set(this.activehrs, 'from', firstHrs)
        Vue.set(this.activehrs, 'to', firstHrs)
      } else {
        Vue.set(this.activehrs, 'from', lastHrs)
        // Vue.set(this.activehrs, 'to', lastHrs)
      }
      Vue.set(this.activehrs, 'position', position)
    },
    addTimeslot () {
      if (this.activehrs.position === 'after') {
        this.activehrs.hrs[this.activehrs.day] += '|' + this.activehrs.from + '-' + this.activehrs.to
      } else {
        this.activehrs.hrs[this.activehrs.day] = this.activehrs.from + '-' + this.activehrs.to + '|' + this.activehrs.hrs[this.activehrs.day]
      }
      this.activehrs.hrs[this.activehrs.day] = this.trimPipes(this.activehrs.hrs[this.activehrs.day])
      this.hrsDialog = false
      if (this.autoSave) {
        this.save(this.hrs)
      }
    }
  }
}
</script>
